export const Pending = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.992 0C3.576 0 0 3.584 0 8C0 12.416 3.576 16 7.992 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 7.992 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4ZM8.4 4H7.2V8.8L11.4 11.32L12 10.336L8.4 8.2V4Z"
        fill="#666666"
      />
    </svg>
  );
};
export const Cancel = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.072 4.8L8 6.872L5.928 4.8L4.8 5.928L6.872 8L4.8 10.072L5.928 11.2L8 9.128L10.072 11.2L11.2 10.072L9.128 8L11.2 5.928L10.072 4.8ZM8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z"
        fill="#666666"
      />
    </svg>
  );
};

export const BalanceIcon = ({
  fill = '#2F6FA7',
  width = '14',
  height = '14',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.43701 4.33333C6.43701 3.96533 6.73568 3.66667 7.10368 3.66667C7.47168 3.66667 7.77035 3.96533 7.77035 4.33333C7.77035 4.70133 7.47168 5 7.10368 5C6.73568 5 6.43701 4.70133 6.43701 4.33333ZM6.43701 6.33333C6.43701 5.96533 6.73568 5.66667 7.10368 5.66667C7.47168 5.66667 7.77035 5.96533 7.77035 6.33333V9.66667C7.77035 10.0347 7.47168 10.3333 7.10368 10.3333C6.73568 10.3333 6.43701 10.0347 6.43701 9.66667V6.33333ZM7.10368 12.3333C4.16301 12.3333 1.77035 9.94067 1.77035 7C1.77035 4.05933 4.16301 1.66667 7.10368 1.66667C10.0443 1.66667 12.437 4.05933 12.437 7C12.437 9.94067 10.0443 12.3333 7.10368 12.3333ZM7.10368 0.333332C3.42168 0.333332 0.437012 3.318 0.437012 7C0.437012 10.682 3.42168 13.6667 7.10368 13.6667C10.785 13.6667 13.7703 10.682 13.7703 7C13.7703 3.318 10.785 0.333332 7.10368 0.333332Z"
        fill={fill}
      />
    </svg>
  );
};

export const ForeignTransIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.5C7.47 2.5 3 6.97 3 12.5C3 18.03 7.47 22.5 13 22.5C18.53 22.5 23 18.03 23 12.5C23 6.97 18.53 2.5 13 2.5ZM13 20.5C8.59 20.5 5 16.91 5 12.5C5 8.09 8.59 4.5 13 4.5C17.41 4.5 21 8.09 21 12.5C21 16.91 17.41 20.5 13 20.5Z"
        fill="#666666"
      />
      <path
        d="M7 15.5V9.5H11.3711V10.8971H8.82774V12.053H11.1297V13.3753H8.82774V15.5H7Z"
        fill="#666666"
      />
      <path
        d="M12.8529 15.5L14.685 12.4938V12.4605L12.8486 9.5H14.9781L15.9566 11.4127H15.9911L16.974 9.5H19L17.0731 12.4688V12.5021L18.9914 15.5H16.9567L15.8834 13.6913H15.8489L14.7841 15.5H12.8529Z"
        fill="#666666"
      />
      <rect x="10" y="4.5" width="2" height="3" fill="#666666" />
      <rect x="14" y="4.5" width="2" height="3" fill="#666666" />
      <rect
        x="21"
        y="6.5"
        width="2"
        height="15"
        transform="rotate(90 21 6.5)"
        fill="#666666"
      />
      <rect
        x="21"
        y="16.5"
        width="2"
        height="16"
        transform="rotate(90 21 16.5)"
        fill="#666666"
      />
      <rect x="10" y="17.5" width="2" height="3" fill="#666666" />
      <rect x="14" y="17.5" width="2" height="3" fill="#666666" />
    </svg>
  );
};

export const CloseIcon = ({
  fill = '#2F6FA7',
  width = '24',
  height = '25',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M14.072 9.67695L12 11.749L9.928 9.67695L8.8 10.805L10.872 12.877L8.8 14.949L9.928 16.077L12 14.005L14.072 16.077L15.2 14.949L13.128 12.877L15.2 10.805L14.072 9.67695ZM12 4.87695C7.576 4.87695 4 8.45295 4 12.877C4 17.301 7.576 20.877 12 20.877C16.424 20.877 20 17.301 20 12.877C20 8.45295 16.424 4.87695 12 4.87695ZM12 19.277C8.472 19.277 5.6 16.405 5.6 12.877C5.6 9.34895 8.472 6.47695 12 6.47695C15.528 6.47695 18.4 9.34895 18.4 12.877C18.4 16.405 15.528 19.277 12 19.277Z"
        fill={fill}
      />
    </svg>
  );
};

export const SuccessIcon = ({
  fill = '#1E8240',
  width = '24',
  height = '24',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_13731_279322)">
        <path
          d="M8.99989 16.1703L5.52989 12.7003C5.13989 12.3103 4.50989 12.3103 4.11989 12.7003C3.72989 13.0903 3.72989 13.7203 4.11989 14.1103L8.29989 18.2903C8.68989 18.6803 9.31989 18.6803 9.70989 18.2903L20.2899 7.71031C20.6799 7.32031 20.6799 6.69031 20.2899 6.30031C19.8999 5.91031 19.2699 5.91031 18.8799 6.30031L8.99989 16.1703Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_13731_279322">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CancelIcon = ({ fill = '#FFF', width = '24', height = '24' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_12114_212658)">
        <path
          d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12114_212658">
          <rect width="24" height="24" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};
export const WarningIcon = ({
  fill = '#003A45',
  width = '14',
  height = '14',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M13.8097 3.88617L22.725 18.8793C23.2962 19.8399 22.9489 21.0636 21.9493 21.6125C21.6343 21.7855 21.2779 21.8765 20.9151 21.8765H3.08455C1.93329 21.8765 1 20.9796 1 19.8732C1 19.5246 1.09467 19.182 1.27465 18.8793L10.1899 3.88617C10.7611 2.92557 12.0345 2.59184 13.0341 3.14075C13.3572 3.31822 13.6251 3.5756 13.8097 3.88617ZM11.9998 4.88005L3.08455 19.8732H20.9151L11.9998 4.88005ZM11.9998 16.1171C12.7194 16.1171 13.3027 16.6777 13.3027 17.3692C13.3027 18.0606 12.7194 18.6212 11.9998 18.6212C11.2803 18.6212 10.697 18.0606 10.697 17.3692C10.697 16.6777 11.2803 16.1171 11.9998 16.1171ZM10.9575 10.8586C10.9575 9.52311 11.6524 8.85537 13.0421 8.85537V14.8651H10.9575C10.9575 13.5296 10.9575 12.1941 10.9575 10.8586Z"
        fill={fill}
      />
    </svg>
  );
};
